import { createSlice } from "@reduxjs/toolkit";
import { getTagsThunk } from "../../thunk";

const formSlice = createSlice({
  name: 'tags',
  initialState: {
    list: null,
    loading: false,
    error: null,
  },
  extraReducers: {
    [getTagsThunk.pending]: state => {
      state.loading = true;
    },
    [getTagsThunk.fulfilled]: (state, action) => {
      state.loading = false;
      const { data } = action.payload;
      state.list = data;
    },
    [getTagsThunk.rejected]: state => {
      state.loading = false;
    },
  }
})

// Extract the action creators object and the reducer
const { reducer } = formSlice;
// Export the reducer, either as a default or named export
export default reducer;